import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import Metric from '../../../../components/stats/Metric';
import MetricsContainer from '../../../../components/stats/MetricsContainer';
import HelperMethods from '../../../../services/exports/HelperMethods';
import useApiClient from '../../../../hooks/api/useApiClient';
import { useGetOnboardingStatsQuery } from '../../../../store/api-slices';
import DrawerDetails, { OnboardingQualityScore } from './DrawerDetails';

const Metrics = [
  { key: 'go_lives', has_details: true },
  { key: 'avg_quality_score', has_details: false },
];

function OnboardingTeam({ dateRangeFilter, renderDateRangeFilter }) {
  const { t } = useTranslation(null, { keyPrefix: 'Views:Dashboard:ServiceProvider:OnboardingTeam.metrics' });

  const { StatsManager } = useApiClient();

  const { data, isFetching } = useGetOnboardingStatsQuery({ apiManager: StatsManager, ...dateRangeFilter });

  const getItem = (item) => {
    if (!item) {
      return;
    }

    return {
      value: item.current,
      previous: item.prev,
      change: item.prev ? HelperMethods.percentagePart(item.current - item.prev, item.prev) : null,
    };
  };

  function detailsModalRenderer(metric) {
    return function ({ onClose }) {
      return <DrawerDetails metric={metric} dateRangeFilter={dateRangeFilter} onClose={onClose} />;
    };
  }

  return (
    <>
      {renderDateRangeFilter({
        excludeFilters: ['*'],
        customFilters: [
          {
            id: 'filter_period_today',
            period: 'today',
          },
          {
            id: 'filter_period_yesterday',
            period: 'yesterday',
          },
          {
            id: 'filter_period_this_week',
            period: 'this_week',
          },
          {
            id: 'filter_period_last_week',
            period: 'last_week',
          },
          {
            id: 'filter_period_this_month',
            period: 'this_month',
          },
          {
            id: 'filter_period_last_month',
            period: 'last_month',
          },
        ],
      })}
      <MetricsContainer
        metrics={Metrics.map((item) => (
          <Metric
            loading={isFetching}
            key={item.key}
            name={t(item.key)}
            items={getItem(data?.[item.key])}
            excludedHistoryMetrics={['*']}
            renderMetricDetails={
              item.has_details && data?.[item.key]?.current > 0 ? detailsModalRenderer(item.key) : null
            }
          />
        ))}
      />
      <Table
        columns={[
          { key: 'name', title: t('managers.fields.name'), dataIndex: 'name' },
          {
            key: 'go_lives',
            title: t('managers.fields.go_lives'),
            className: '!text-right',
            dataIndex: 'go_lives',
          },
          {
            key: 'avg_quality_score',
            title: t('managers.fields.avg_quality_score'),
            className: '!text-right',
            render: (item) => <OnboardingQualityScore score={item.avg_quality_score} />,
          },
        ]}
        dataSource={data?.managers}
        loading={isFetching}
        pagination={false}
        title={() => <h5>{t('managers.title')}</h5>}
        rowHoverable={false}
        className="mt-xl"
      />
    </>
  );
}

export default OnboardingTeam;
